<template>
  <div
    class="setting_main_contents"
    id="job-main-content"
  >
    <div :class="{'overlay_setting':isLoadingData}">
      <i :class="{'loadding_setting': isLoadingData}"></i>
    </div>
    <div class="setting_heading">
      <h1 class="setting_heading_title">
        {{ jobInformationProperty.TAB_HEADER }}
      </h1>
      <p class="setting_heading_explain">
        {{ jobInformationProperty.SUB_HEADER }}
      </p>
    </div>
    <div class="setting_tab">
      <div class="setting_tab_nav">
        <ul class="setting_tab_nav_list">
          <li
            id="t1"
            class="setting_tab_nav_item is_active"
            @click.prevent="changeNavTab(1)"
          >
            <span class="setting_tab_nav_text">
              {{ jobInformationProperty.JOB_INFORMATION_TAB_TITLE }}
            </span>
          </li>
        </ul>
      </div>
      <div v-show="navTab === JOB_INFORMATION_TAB" class="setting_tab_content">
        <div class="setting_tab_content_panel is_active">
          <JobInformationTab
            @updateRedisData="updateRedisData"
            @resetMasterData="resetMasterData"
          />
        </div>
      </div>
    </div>
    <div class="setting_footer">
    </div>
  </div>
</template>

<script>
import JobInformationTab from "./JobInformationComponents/JobInformationTab.vue";
import jobInformationProperty from "../../../properties/job_information/job-information.json";
import * as generalLabels from "../../../properties/general_page/generalpage-labels.json";
import generalService from "../../../services/GeneralService";
import labelInformationTabProperties from "../../../properties/job_information/job_information_tab/job-information-labels.json";
import jobInformationService from '../../../services/JobInformationService';
import Vue from "vue";
import entrySettingNotificationProperty from "../../../properties/entry_screen/notifications.json";
import * as generalMessages from "../../../properties/general_page/generalpage.json";
import labelMasterProperties from "../../../properties/master_screen/master-labels.json";
import masterSettingsService from "../../../services/MasterSettingsService";
import messageMasterProperties from "../../../properties/master_screen/master-messages.json";

const JOB_INFORMATION_TAB = 1;
const START_PAGE_TITLE = generalLabels.START_TITLE_PAGE + " > " + jobInformationProperty.PAGE_TITLE + " > ";

export default {
  name: "JobInformation",
  props: ["groupName", "userId", "token"],
  components: {
    JobInformationTab
  },
  data: function () {
    return {
      jobInformationProperty: jobInformationProperty,
      labelInformationTabProperties:labelInformationTabProperties,
      navTab: JOB_INFORMATION_TAB,
      JOB_INFORMATION_TAB: JOB_INFORMATION_TAB,
      log: {
        info: {},
      },
      isLoadingData: true,
    };
  },
  async created() {
    document.title = START_PAGE_TITLE + jobInformationProperty.JOB_INFORMATION_TAB_TITLE;
    this.isLoadingData = false;
  },
  methods: {
    updateJobInformation(){
      jobInformationService.deleteJobDetailInRedis(this.log.hash, this.token).catch(e => {
        console.log(e);
      });
    },

    updateDispatchJobInformation(){
      jobInformationService.deleteDispatchJobDetailInRedis(this.log.hash, this.token).catch(e => {
        console.log(e);
      });
    },

    updateCompanyInformation(){
      jobInformationService.deleteCompanyDetailInRedis(this.log.hash, this.token).catch(e => {
        console.log(e);
      });
    },

    async sendLogger(loggerData) {
      this.logs = loggerData;
      await generalService
        .sendLogger(this.logs.hash, this.logs.info.path, this.logs)
        .then((response) => {
          if (response.status === 200) {
            return true;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    async createLogger(action) {
      this.log.groupName = this.groupName;
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = action;
      this.log.info.path = window.location.href;
      this.log.info.userId = this.userId;
      await this.sendLogger(this.log);
    },

    async updateRedisData() {
      this.isLoadingData = true;
      Vue.$toast.clear();
      await this.createLogger("Menu " + generalLabels.FIFTH_TAB + "-Tab " + jobInformationProperty.JOB_INFORMATION_TAB_TITLE + "-Click button " + labelInformationTabProperties.BUTTON_UPDATE_REDIS_DATA);
      Promise.all([this.updateJobInformation(), this.updateDispatchJobInformation(), this.updateCompanyInformation()]).then(() => {
        Vue.$toast.success(entrySettingNotificationProperty.UPDATE_SUCCESSFUL, {
              position: "bottom-right",
              duration: 3000,
              queue: true
            }
        );
      }).catch(e => {
        console.log(e);
        Vue.$toast.error(generalMessages.ERROR_SAVE_DATA, {
              position: "bottom-right",
              duration: 3000,
              queue: true
            }
        );
      }).finally(() => {
          this.isLoadingData = false;
      });
    },

    async resetMasterData() {
      this.isLoadingData = true;
      await this.createLogger("Menu " + generalLabels.FOURTH_TAB + "-Click button " + labelMasterProperties.BUTTON_RESET_MASTER_DATA);
      Vue.$toast.clear();
      await masterSettingsService.resetMasters(this.log.hash, this.token).then(() => {
        Vue.$toast.success(
            messageMasterProperties.RESET_MASTER_ITEM_SUCCESSFUL, {
              position: "bottom-right",
              duration: 3000,
            }
        );
      }).catch(e => {
        console.log(e);
        Vue.$toast.error(generalMessages.ERROR_SAVE_DATA, {
          position: "bottom-right",
          duration: 3000,
        });
      }).finally(() => {
        this.isLoadingData = false;
      });
    },
  },
};
</script>
